enum Tables {
  CLIENTS = 'clients',
  QUESTIONS = 'questions',
  UNITES = 'unites',
  REPONSES = 'reponses',
}

export default Tables;